module.exports = __webpack_public_path__ + "KaTeX_Main-Bold.dbc57f15.woff";